import { Controller, useFormContext } from "react-hook-form";

import { Grid, Paper, Stack, Typography } from "@mui/material";

import { CustomDatePicker, CustomInputField } from "@/features/ui";
import dayjs from "dayjs";

export const DeliveryDetailSection = () => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={2.5}>
        <Typography variant="h6">Detail Klaim Kirim</Typography>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
            <Controller
              name="transactionDate"
              control={control}
              render={({ field, fieldState }) => (
                <CustomDatePicker
                  value={field.value}
                  onChange={field.onChange}
                  required
                  label="Tanggal Pengiriman"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                  maxDate={dayjs().add(2, "day")}
                />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
            <CustomInputField
              name="note"
              label="Catatan"
              register={register}
              helperText={errors.note?.message}
              error={Boolean(errors.note)}
            />
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
};
